import { render, staticRenderFns } from "./DistributorClientUINavBar.vue?vue&type=template&id=c3fbe0b6&"
import script from "./DistributorClientUINavBar.vue?vue&type=script&lang=js&"
export * from "./DistributorClientUINavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports